/*
 * Native Possum — np-our-picks.js
 * Behaviour for sections/hp-our-picks.liquid (see its header).
 * Loaded where it used to be written inline, without defer, so it runs at the same
 * moment as before (it sets up what the section looks like on load).
 */
  (function () {
    'use strict';
    var section = document.currentScript.previousElementSibling;
    if (!section || !section.hasAttribute('data-np-picks')) return;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
    var underline = section.querySelector('.np-picks-tabs__underline');
    var grid = section.querySelector('.np-our-picks__grid');

    function place() {
      var active = section.querySelector('.np-picks-tab.is-active');
      if (!underline || !active) return;
      underline.style.left = active.offsetLeft + 'px';
      underline.style.width = active.offsetWidth + 'px';
    }

    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
      place();
      if (grid) grid.scrollLeft = 0;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!step) return;
        e.preventDefault();
        var next = tabs[(i + step + tabs.length) % tabs.length];
        next.focus();
        select(next);
      });
    });

    new ResizeObserver(place).observe(section.querySelector('.np-picks-tabs'));
    place();
  })();
